<template>
  <Select v-if="options.length > 1" v-model="culture" :size="size">
    <option
      v-for="option in options"
      :key="option.culture"
      :value="option.culture"
    >
      {{ option.name }}
    </option>
  </Select>
</template>

<script setup lang="ts">
import { app } from "@/app.context";
import { Culture } from "@/dictionary";
import { ILocalizedLanguage } from "lib/eduConfigurationServiceClient";
import { computed, watch } from "vue";
import { ref } from "vue";

const culture = ref<Culture>(app.culture);

export type CultureOption = {
  culture: Culture;
  name: string;
};

defineProps<{
  size?: string;
}>();

watch(culture, (newCulture) => {
  // replace current location with new culture
  const url = new URL(window.location.href);
  url.searchParams.set("culture", newCulture);

  location.replace(url.toString());
});
const options = computed(() => {
  if (!app.tenant.languages) return [];
  const mainCulture = mapToCultureOption(app.tenant.languages.mainLanguage);
  const otherCultures =
    app.tenant.languages.otherLanguages.map(mapToCultureOption);
  return [mainCulture, ...otherCultures];
});

function mapToCultureOption(language: ILocalizedLanguage): CultureOption {
  return {
    name: language.name,
    culture: language.locale!.value as Culture,
  };
}
</script>
